export default __webpack_public_path__ + "static/media/Research.0cb3f896.png";